<template>
  <div id="edit_quick_messages">
    <van-nav-bar :title="$t('title.edit_quick_messages')" placeholder fixed safe-area-inset-top @click-left="onClickLeft" left-arrow>
      <template #right>
        <div class="edit_quick_messages_btn" @click="onClickRight">{{ $t('column.submit') }}</div>
      </template>
    </van-nav-bar>
    <van-row>
      <van-col span="22" offset="1" class="edit_quick_messages_title"><span>*</span> {{ $t('column.selling_price_coins') }}</van-col>
      <van-col span="22" offset="1" class="edit_quick_messages_centent">
        <van-field
            v-model="quick_message"
            rows="6"
            autosize
            type="textarea"
            maxlength="100"
            show-word-limit
        />
      </van-col>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";

export default {
  data() {
    return {
      quick_message: '',
    }
  },
  created() {
    this.get_list()
  },
  methods: {
    onClickRight() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=save_quick_message",{
        params:{uid: uid, token: token, quick_message: this.quick_message }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        console.log(res.data)
        Toast(res.data.error)
      })
    },
    get_list() {
      this.loading = true;
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=coin_seller&act=get_quick_message", {
        params: {
          uid: uid,
          token: token
        }
      }).then(res => {
        if(res.data.status !==1){
          Toast(res.data.error)
        }else{
          this.quick_message = res.data.data.quick_messages
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/edit_quick_messages.vue